import { Controller } from "@hotwired/stimulus"
import { post } from '@rails/request.js'

// TODO : To be updated when structure the form with Tailwind
// TODO : Use Stimulus value to translate the messages

export default class extends Controller {
  static targets = ["pincodeForm", "group", "input", "hiddenOutput", "actionBtn", "backupForm", "backupOtpInput"]

  connect() {
    this.completedSteps = []
    this.submitting = false
    this.submitUrl = this.actionBtnTarget.dataset.submitUrl

    this.inputs.forEach((input, i) => {
      input.addEventListener("keydown", (e) => this.onKeyDown(e, i))
      input.addEventListener("input", (e) => this.onInput(e, i))
      input.addEventListener("paste", this.handlePaste.bind(this))
      input.addEventListener("click", this.focusLatestInput.bind(this))
      input.addEventListener("mousedown", e => e.preventDefault())
      input.addEventListener("contextmenu", e => e.preventDefault())
    })

    this.resetInputs()
    this.element.addEventListener("click", () => this.focusLatestInput())
  }

  resetInputs() {
    this.completedSteps = []

    this.inputs.forEach((input, i) => {
      input.value = ""
      input.disabled = i !== 0
    })

    this.hiddenOutputTarget.value = ""
    this.inputs[0].focus()
  }

  onKeyDown(event, index) {
    const key = event.keyCode

    if ([37, 38, 39, 40].includes(key)) return event.preventDefault()

    if (key === 8 || key === 46) {
      this.goToPreviousInput()
      event.preventDefault()
    }
  }

  onInput(event, index) {
    const input = event.target

    if (!/^[0-9]$/.test(input.value)) {
      input.value = ""
      return
    }

    this.completedSteps.push(index)
    this.goToNextInput()
  }

  goToNextInput() {
    if (this.completedSteps.length === this.inputs.length) {
      this.inputs.forEach(i => i.disabled = true)
      this.submitForm()
    } else {
      const nextIndex = this.completedSteps.length

      if (this.inputs[nextIndex]) {
        this.inputs[nextIndex].disabled = false
        this.inputs[nextIndex].focus()
      }
    }

    this.setActionButton("arrow")
  }

  goToPreviousInput() {
    const lastIndex = this.completedSteps.pop()

    if (lastIndex !== undefined) {
      this.inputs[lastIndex].value = ""
      this.inputs[lastIndex].disabled = false
      this.inputs[lastIndex].focus()
      for (let i = lastIndex + 1; i < this.inputs.length; i++) {
        this.inputs[i].disabled = true
      }
    } else {
      this.resetInputs()
    }
  }

  focusLatestInput() {
    const i = this.completedSteps.length

    if (this.inputs[i]) {
      this.inputs[i].focus()
    } else {
      this.inputs[0].focus()
    }
  }

  handlePaste(event) {
    const pasteData = event.clipboardData.getData("text")
    event.preventDefault()

    if (this.submitting) return

    if (/^\d{6}$/.test(pasteData)) {
      this.resetInputs()
      for (let i = 0; i < pasteData.length; i++) {
        this.inputs[i].value = pasteData[i]
        this.completedSteps.push(i)
      }
      this.goToNextInput()
    } else {
      this.setActionButton("error", "Valeur copiée non valide")
    }
  }

  showBackup(event) {
    event.preventDefault()
    this.pincodeFormTarget.classList.add("hidden")
    this.backupFormTarget.classList.remove("hidden")
    this.backupOtpInputTarget.focus()
  }

  submitForm() {
    if (this.submitting) return

    this.submitting = true
    const values = Array.from(this.inputs).map(i => i.value).join("")
    this.hiddenOutputTarget.value = values

    this.setActionButton("loader")

    post(this.submitUrl, {
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: new URLSearchParams(new FormData(this.pincodeFormTarget))
    })
    .then(data => data.response.json())
    .then(data => {
      if(data.response === 1) {
        this.setActionButton("check")
        window.location.href = data.redirect_url
      } else {
        this.handleInvalidCode()
      }
    })
    .catch(() => {
      this.handleInvalidCode()
    })
  }

  handleInvalidCode() {
    this.setActionButton("error", "Code invalide")
    this.resetInputs()
    this.submitting = false
  }

  setActionButton(state, message = "") {
    const btn = this.actionBtnTarget
    btn.classList.remove("btn-default", "btn-primary", "btn-success", "btn-danger")
    btn.style.pointerEvents = "none"

    switch (state) {
      case "arrow":
        btn.innerHTML = `<i class='fa fa-chevron-left position-left'></i> Retour`
        btn.classList.add("btn-default")
        btn.style.pointerEvents = "auto"
        break
      case "loader":
        btn.innerHTML = `<i class='fa fa-spinner fa-spin'></i>`
        btn.classList.add("btn-primary")
        break
      case "check":
        btn.innerHTML = `<i class='fa fa-check'></i>`
        btn.classList.add("btn-success")
        break
      case "error":
        btn.innerHTML = `<i class='fa fa-times position-left'></i> ${message}`
        btn.classList.add("btn-danger")
        setTimeout(() => this.setActionButton("arrow"), 1500)
        break
    }
  }

  get inputs() {
    return this.inputTargets
  }
}
